import { Country, EnumSchema, FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const CreditSafeCompanySearchResultSchema = z
    .object({
        connectionId: z.string(),
        name: z.string(),
        country: EnumSchema(Country),
        vatNumber: z.string().optional(),
        status: z.string().optional(),
        address: z.string().optional(),
    })
    .strict();

export class CreditSafeCompanySearchResult extends FromSchema(CreditSafeCompanySearchResultSchema) {
    connectionId: string;
    name: string;
    status: string;
    country: Country;
    vatNumber?: string;
    address?: string;
}
